module.exports = __webpack_public_path__ + "static/media/ham_gas_ven.16116a64.png";